export const BUTTON_CLICKED_EVENT = 'BUTTON_CLICKED_EVENT'
export const LINK_CLICKED_EVENT = 'LINK_CLICKED_EVENT'
export const BLOG_CLICKED_EVENT = 'BLOG_CLICKED_EVENT'
